<template>
<div :class="'classInteraction role'+curRole">
  <template  v-if="curRole==5">
     <div class='top1'>
       <img :src='require("@/assets/img/peo"+gender+".png")' class='img'>
       <p><span class='name'>姓名:{{loginUser.studentName}}</span><br>{{loginUser.className}}&nbsp;{{loginUser.schoolName}}</p>
     </div>
     <van-list v-model="isLoading" :finished='isFinish' @load='onLoad' :offset='70' :finished-text="finishText">
         <div class='interactionList'  v-for="(item,i) in list" :key='i'>
            <div class="title">{{item.subjectName}}</div>
            <p class="gray flex-between"><span>主讲老师：{{item.teacherName}}</span><span>{{item.interactTime}}</span></p>
            <div class="con">
                <p class="head"><span>课堂互动</span><span>答题</span><span>正确率</span></p>
                <p v-for="(obj,j) in item.subjectInfoList" :key='j' class='bj'>
                  <span>{{typeList[obj.interactiveMode]}}</span>
                  <span>{{obj.questionNum}}</span>
                  <span>{{obj.accuracy}}%</span>
                </p>
            </div>
         </div>
     </van-list>
  </template>
  <template v-else>
     <div class='top1'>
       <img src='@/assets/img/step/re11.png' class='img'>
       <p><span class='name'>课堂互动</span><br>{{curClass.className}}</p>
     </div>
     <van-list v-model="isLoading" :finished='isFinish' @load='onLoad' :offset='70' :finished-text="finishText">
         <div class='interactionList'  v-for="(item,i) in list" :key='i' @click="toDetail(item)">
            <div class="title">{{item.subjectName}}</div>
            <p class="gray flex-between"><span>主讲老师：{{item.teacherName}}</span><span>{{item.interactTime}}</span></p>
            <div class="con1">
               <p class="border"><span class='color'>{{item.studentNum}}</span><br><span class='gray'>参与学生(个)</span></p>
               <p><span class='color'>{{item.accuracy}}</span>%<br><span class='gray'>平均正确率</span></p>
            </div>
         </div>
     </van-list>
  </template>

     <div class='noData' v-if="text&&list.length==0"><div><img :src='require("@/assets/img/nodata.png")'><br />{{text}}</div></div>
</div>
</template>
<script>
import {statOfParentPaged,statOfTeacherPaged} from "@/api/api.report";
  export default {
    data() {
      return {
        list:[],
        isLoading:false,
        pageNo:1,
        pageSize:10,
        total:0,
        isFinish:true,
        finishText:'',
        details:'',
        text:'',
        curRole:this.$store.state.loginUser.currentUserType,//3老师，5家长
        gender:this.$store.state.loginUser.gender||'3',//性别
        typeList:{'TRUE_OR_FALSE':'判断','SINGLE_CHOICE':'单选','MULTIPLE_CHOICE':'多选','ANSWERED_QUICKLY':'抢答','PAPER_PEN_INTERACTION':'纸笔互动',
           'CLASS_TEST':'随堂测','WORD_DICTATION':'单词听写','CHINESE_CALLIGRAPHY':'中文练字','UNKNOWN':'其他题型'},
        curClass:''
      }
    },
    created(){
      if(this.curRole==3){//老师
         this.curClass=JSON.parse(sessionStorage.classes);
         this.getTeaList()
      }else{
         this.getParentList();
      }
     
    },
    methods: {
      getParentList(){
        this.text='';
         statOfParentPaged({
              studentId:this.loginUser.studentId,
              classId:this.loginUser.classId,
              pageNo:this.pageNo,
              pageSize:this.pageSize,
           }).then((data) => {
            if (data && data.result.list.length>0) {
                  this.list=this.list.concat(data.result.list);
              }
             this.isLoading=false;
             this.total=data.result.totalNum;
              if(this.total==this.list.length){
                this.isFinish=true;
                if(this.total>0){
                   this.finishText='-- 没有更多了 --';
                }else{
                  this.text='暂无数据';
                }
               
              }else{
                this.isFinish=false;
              }
              // if(this.pageNo==data.result.totalPage){
              //   this.isFinish=true;
              //   this.isLoading=false;
              //   this.finishText='-- 没有更多了 --';
              // }
           })
      },
      getTeaList(){
        this.text='';
        statOfTeacherPaged({
              classId:this.curClass.classId,
              pageNo:this.pageNo,
              pageSize:this.pageSize,
           }).then((data) => {
             if (data && data.result.list.length>0) {
                  this.list=this.list.concat(data.result.list);
              }
             this.isLoading=false;
             this.total=data.result.totalNum;
              if(this.total==this.list.length){
                this.isFinish=true;
                if(this.total>0){
                   this.finishText='-- 没有更多了 --';
                }else{
                  this.text='暂无数据';
                }
              }else{
                this.isFinish=false;
              }
              // if(this.pageNo==data.result.totalPage){
              //   this.isFinish=true;
              //   this.isLoading=false;
              //   this.finishText='-- 没有更多了 --';
              // }
           })
      },
      toDetail(item){
        sessionStorage.setItem('details',JSON.stringify(item));
        this.gotoUrl('interactiveDetail');
      },
       onLoad(){
         if(this.isFinish) return
           this.pageNo++;
            if(this.curRole==3){//老师
              this.getTeaList()
            }else{
              this.getParentList();
            }
         
       }
    },
  }
</script>
<style lang="scss">
.classInteraction{
  position: absolute;
  // top: 0px;
  left: 0px;
  height: 100%;
  width: 100%;
  overflow: auto;
  background: url(../../assets/img/step/re12.png) no-repeat left top;
  padding:.27rem .15rem;
  background-size:  100% 1.6rem;
  margin-top: -0.2rem;
  &.role3{
    background: url(../../assets/img/step/re13.png) no-repeat left top;
    background-size: 100% 1.6rem;
  }
  .top1{
    display: flex;
    align-items:center;
    font-size:.13rem;
    color:#fff;
    margin-bottom: .3rem;
    margin-top: .2rem;
    img{
      border-radius:50%;
      width: .46rem;
      height:.46rem;
      margin-right:10px;
    }
    .name{
      font-size: .16rem;
      padding-bottom: .06rem;
      display: inline-block;
      color: #fff;
    }
  }
  .interactionList{
    padding:.12rem .12rem .16rem;
    background:#fff;
    border-radius: 12px;
    font-size: .14rem;
    color: #333;
    margin-bottom: .12rem;
    .title{
        font-size: .16rem;
        margin-bottom: .05rem;
        font-weight: bold;
    }
    .con{
      margin-top: .2rem;
      p{
        display: flex;
        line-height: .4rem;
        span{
          flex:1;
          text-align: center;
        }
      }
      .bj:nth-child(even){
        background:#f2f9ff;
      }
    }
    .con1{
       display: flex;
       margin-top: .24rem;
       p{
         flex: 1;
         text-align: center;
         position: relative;
         .color{
            font-size:.23rem;
            margin-right: 5px;
            margin-bottom: .04rem;
            display: inline-block;
         }
         &.border::after{
            content: '';
            width: 1px;
            height: 50%;
            display: inline-block;
            position: absolute;
            background:rgba(0,0,0,.2);
            top: 30%;
            right: 0px;
         }
       }
    }
  }
   
    .gray{
            font-size: .12rem;
             color:rgba(0,0,0,.6);
     }
   
}
</style>